import React from "react";

function LocationSvg({ className }) {
    return (
        <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.3501 3.78339C18.1834 3.38339 15.1167 4.35006 12.7001 6.48339C10.1834 8.71672 8.7334 11.9667 8.7334 15.4167V15.8501C8.7334 19.2334 9.6834 22.5001 11.4667 25.3001L17.5334 34.8334C18.0667 35.6834 18.9834 36.1834 19.9667 36.1834C20.9501 36.1834 21.8667 35.6834 22.4001 34.8334L28.4667 25.3001C30.2501 22.4834 31.2001 19.2167 31.2001 15.8501C31.2001 9.66672 26.9501 4.46672 21.3167 3.78339H21.3501ZM19.9834 21.2001C17.4501 21.2001 15.4001 19.1501 15.4001 16.6167C15.4001 14.0834 17.4501 12.0334 19.9834 12.0334C22.5167 12.0334 24.5667 14.0834 24.5667 16.6167C24.5667 19.1501 22.5167 21.2001 19.9834 21.2001Z" fill="#9FE870" />
        </svg>
    );
}

export default LocationSvg;
